import {store} from '../app/store';
import {
  resetExistingSub,
  setActiveSub,
  setBearerToken,
  setCurrentSubDetails,
  setExistingSub,
  setExistingSubDetails,
  setLoading,
  setRefreshToken,
} from '../features/user/userSlice';
import {checkBearerTokenValidity} from '../Utility/checkToken';
import {checkActiveNoSub, checkUserForSub} from '../Utility/checkUserForSub';
import {axiosInstance} from './axios/AxiosInstance';

export const unsubscribe = (userName, navigate, subscriptionId, token) => {
  let tokenInterceptor = axiosInstance.interceptors.request.use(
    config => {
      checkBearerTokenValidity(userName, navigate);
      console.log('checked bearer');
      return config;
    },
    error => {
      return Promise.reject(error);
    },
  );

  axiosInstance
    .delete(`/auth/unsubscribe?SubscriptionId=${subscriptionId}`, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    })
    .then(res => {
      console.log('unsubscribed');
      axiosInstance.interceptors.request.eject(tokenInterceptor);
      window?.localStorage?.setItem('refreshToken', res?.data?.Refresh);
      window?.localStorage?.setItem('bearerToken', res?.data?.Token);
      store.dispatch(setBearerToken(res.data.Token));
      store.dispatch(setRefreshToken(res.data.Refresh));
      //store.dispatch(setActiveSub(false));
      store.dispatch(resetExistingSub());
      store.dispatch(setExistingSub(false));
      if (res.data?.Subscriptions) {
        res.data?.Subscriptions?.forEach(sub => {
          if (sub?.Subscribed) {
            store.dispatch(setCurrentSubDetails(sub));
          } else {
            store.dispatch(setExistingSubDetails(sub));
          }
        });
      }
      //check if the user has an active subscription
      store.dispatch(setActiveSub(checkUserForSub(res?.data)));
      store.dispatch(setExistingSub(checkActiveNoSub(res?.data)));
      //store.dispatch(setCurrentSubDetails({}));
      store.dispatch(setLoading(false));
      navigate('/subexpired');
    })
    .catch(err => console.log('Error in unsubscribing', err));
};
